import React from "react";

export default function NewsItem({ title, desc, date }) {
  return (
    <div className="border-b border-slate-100 pb-4 last:border-0">
      <h4 className="font-semibold text-slate-800 mb-1">{title}</h4>
      <p className="text-sm text-slate-600 mb-2">{desc}</p>
      <span className="text-xs text-slate-400">{date}</span>
    </div>
  );
}
